import React, { useEffect, useState, useMemo } from "react";
import { useHistory, generatePath } from "react-router-dom";
import questionService from "../../services/questionService";
import Question from "./risk-question";
import Loading from "../common/loading";
import Markdown from "../common/markdown";
import "./air.css";

const AIRRiskQuiz = ({ description, props }) => {
  // console.log("AIR Risk Quiz props:", props);
  // const questionId = "props.match.params.id";
  const queryID = props.match.params.id ? Number(props.match.params.id) : 1;
  const course = "air";
  const id = "07";
  const pageId = props.match.params.pageId;
  // const noOfQuestions = 5;
  const beforeQuizUrl = "/ethics/ai-regulations/page=7";
  const afterQuizUrl = "/ethics/ai-regulations/page=7";

  const [isLoading, setLoading] = useState(true);
  const [questionId, setQuestionId] = useState(queryID);
  const [answers, setAnswers] = useState();
  const [noOfQuestions, setNoOfQuestions] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState();
  const [isFreshReload, setIsFreshReload] = useState(true);
  const [showExplanation, setShowExplanation] = useState(false);

  const selectedAnswers = useMemo(() => {
    if (answers && answers.answers) {
      return answers.answers;
    } else {
      return [];
    }
  }, [answers]);

  const allowSubmit = useMemo(() => {
    if (answers && answers.num_attempts >= 1) {
      return false;
    }
    if (answers && answers.correct) {
      return false;
    }
    return true;
  }, [answers]);

  const correct = useMemo(() => {
    setShowExplanation(true);
    if (answers) {
      return answers.correct;
    } else {
      return false;
    }
  }, [answers]);

  useEffect(() => {
    // console.log("AIR Risk Quiz mounted");

    if (description) {
      let questionsJSON = JSON.parse(description).allQuestions;

      setNoOfQuestions(questionsJSON.length);
      setCurrentQuestion(questionsJSON[queryID - 1]);
      // Fetch user attempts and stats
      reloadBackendState();

      setLoading(false);
    }
  }, [description]);

  const reloadBackendState = () => {
    questionService
      .getQuestionByChapterId(course, id)
      .then(({ data: response }) => {
        let questionAnswers = response.find(
          (p) => p.quiz_id === parseInt(questionId)
        );
        setAnswers(questionAnswers);
        setLoading(false);
      });
  };

  const onSelectAnswer = (id, index) => {
    const question = { ...currentQuestion };
    question.answers.forEach((answer, idx) => {
      answer.checked = idx === index ? !answer.checked : false;
    });
    // question.answers[index].checked = !currentQuestion.answers[index].checked;
    setCurrentQuestion(question);
  };

  const onPrev = () => {
    if (questionId && questionId > 1) {
      let id = parseInt(questionId) - 1;
      props.history.push(generatePath(props.match.path, { pageId, id }));
    } else {
      props.history.push(beforeQuizUrl);
    }
  };

  const onNext = () => {
    if (questionId && questionId < noOfQuestions) {
      let id = parseInt(questionId) + 1;
      props.history.push(generatePath(props.match.path, { pageId, id }));
    } else {
      props.history.push(afterQuizUrl);
    }
  };

  const onSubmit = () => {
    let questionSubmit = {
      id: currentQuestion.id,
      chapterId: id,
      type: course,
      answers: currentQuestion.answers,
    };
    questionService
      .submitQuestions(questionSubmit)
      .then(({ data: response }) => {
        console.log("Question submitted:", response);
        setAnswers(response.answers);
        setIsFreshReload(false);
        reloadBackendState();
        // setShowExplanation(true);
      });
  };

  const getNextButtonLabel = () => {
    if (questionId && questionId < noOfQuestions) {
      return "Nächste Frage";
    } else {
      return "Weiter";
    }
  };

  const getPrevButtonLabel = () => {
    if (questionId && questionId > 1) {
      return "Vorherige Frage";
    } else {
      return "Zurück";
    }
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <section className="air content question">
          <div className="container-fluid">
            <h1> Quiz: Ordne die KI der Risikogruppe zu! </h1>
            <div className="container-limit my-limit">
              <div className="quiz-subtitle">
                Wie würdest du folgende KI-Technologien zuordnen? Klicke auf ein
                Risiko-Feld und werte deinen Tipp aus, um zu sehen, ob du
                richtig liegst.
              </div>
              <div className="question-wrapper">
                <Question
                  key={currentQuestion.id}
                  question={currentQuestion}
                  onChange={onSelectAnswer}
                  selectedAnswers={selectedAnswers}
                  showAnswers={!allowSubmit}
                />
              </div>
              {/* {!(getMessage().message === "") && (
                <div className={`question-info ${getMessage().color}`}>
                  <span>{getMessage().message}</span>
                </div>
              )} */}
              {answers && showExplanation && (
                <div className="explanation-wrapper">
                  <div className="head-container">
                    <img
                      src={
                        correct
                          ? "/images/air/07_quiz/page7_quizall_check.svg"
                          : "/images/air/07_quiz/page7_quizall_cross.svg"
                      }
                    />
                    <span>{correct ? "Richtig!" : "Ups, falsch getippt."}</span>
                  </div>
                  <Markdown
                    className="explanation-text"
                    children={currentQuestion.explanation}
                  />
                </div>
              )}
              {allowSubmit && (
                <div className="submit-button-wrapper">
                  <button
                    onClick={onSubmit}
                    className="secondBtn primary-color-lightblue-foreground"
                  >
                    Auswerten
                  </button>
                </div>
              )}
              {/* <div className="submit-parent-wrapper"> */}
              {noOfQuestions > 0 && (
                <div className="button-wrapper">
                  {/* <div className="points-panel-wrapper">
                      <span>Punkte</span>
                      <div className="points-panel">{totalPoints}</div>
                    </div> */}
                  {
                    <button onClick={onPrev} className="firstBtn">
                      {getPrevButtonLabel()}
                    </button>
                  }

                  {true && (
                    <button onClick={onNext} className="thirdBtn">
                      {getNextButtonLabel()}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
          {/* </div> */}
        </section>
      )}
    </>
  );
};

export default AIRRiskQuiz;
